import { Link } from "react-router-dom";
import { ChevronRight, Repeat } from "lucide-react";
import { fmtDateTime } from "@/lib/api";
import { StatusBadge } from "@/components/common/StatusBadge";
import { EmptyState } from "@/components/common/Primitives";

export function IssueList({ issues, showVehicle = true }) {
  if (issues.length === 0) return <EmptyState testId="issues-empty" title="No issues" description="Nothing reported for this filter." />;
  return (
    <div className="fv-card divide-y p-1" data-testid="issues-list">
      {issues.map((i) => (
        <Link key={i.id} to={`/issues/${i.id}`} className="fv-dense-row" data-testid={`issue-row-${i.id}`}>
          <div className="min-w-0 flex-1">
            <p className="flex items-center gap-1.5 truncate font-semibold">
              {showVehicle && <span className="text-muted-foreground">{i.vehicle_name || i.registration_no} ·</span>}<span className="truncate">{i.title}</span>
              {i.is_recurring && <span className="inline-flex items-center gap-0.5 rounded-full bg-[#FFF3E0] px-1.5 text-[11px] font-medium text-[#E65100] dark:bg-[#3D1E03] dark:text-[#FFB74D]" data-testid={`recurring-badge-${i.id}`}><Repeat className="h-3 w-3" />Recurring</span>}
            </p>
            <p className="truncate text-[11px] text-muted-foreground">{showVehicle && i.registration_no ? `${i.registration_no} · ` : ""}{i.category} · {fmtDateTime(i.created_at)} · {i.reported_by_name || "—"}{i.assigned_to_name ? ` → ${i.assigned_to_name}` : ""}</p>
          </div>
          <StatusBadge status={i.priority} testId={`issue-priority-${i.id}`} className="hidden sm:inline-flex" />
          <StatusBadge status={i.status} testId={`issue-status-${i.id}`} />
          <ChevronRight className="h-4 w-4 shrink-0 text-muted-foreground" />
        </Link>
      ))}
    </div>
  );
}
